import { render } from "./FDTitle.vue?vue&type=template&id=97b4ca3a"
import script from "./FDTitle.vue?vue&type=script&lang=js"
export * from "./FDTitle.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__